<div
  [innerHTML]="qr"
  (click)="copyQR()"
  class="qr-code-preview"
  [matTooltip]="tooltip"
  [attr.data-cy]="dataCy"
></div>
